import React from "react";
import { Link } from "react-router-dom";
// import Quote from "./Quote";

const serviceCards = [
  {
    title: "Divorces",
    href: "/services/family-law/divorces",
    description:
      "Compassionate legal support for divorce, separation and financial settlement matters.",
  },
  {
    title: "Children Law",
    href: "/services/family-law/children-law",
    description:
      "Advice on child arrangements, parental responsibility and safeguarding family wellbeing.",
  },
  {
    title: "Cohabitation Matters",
    href: "/services/family-law/cohabitation-matters",
    description:
      "Guidance for unmarried couples on property, children and relationship breakdowns.",
  },
  {
    title: "Civil Partnerships & Agreements",
    href: "/services/family-law/civil-partnerships-agreements",
    description:
      "Legal support for civil partnerships, prenuptial agreements and relationship planning.",
  },
];

const FamilyLaw = () => {
  return (
    <div className="relative bg-white pt-20">
      {/* Floating Lady Justice (desktop only, fixed right, non-scrolling, transparent, left-70% showing, below navbar) */}
      <div
        className="pointer-events-none fixed right-0 top-28 xl:top-32 z-10 hidden lg:block select-none"
        aria-hidden="true"
      >
        <img
          src="/lady-justice.png"
          alt=""
          className="h-[580px] xl:h-[680px] 2xl:h-[760px] w-auto max-w-none object-contain opacity-20 translate-x-[30%]"
        />
      </div>

      <section className="relative overflow-hidden bg-[rgb(26,36,58)] py-8 text-white lg:pt-20">
        <div className="container relative mx-auto px-4">
          <div className="max-w-3xl">
            <div className="mb-6 flex items-center gap-3 text-sm font-semibold text-[#C9A04A]">
              <Link to="/" className="hover:text-white">
                Home
              </Link>
              <span>/</span>
              <Link to="/#services" className="hover:text-white">
                Services
              </Link>
              <span>/</span>
              <span>Family Law</span>
            </div>
            <h1 className="mb-6 text-4xl font-bold leading-tight lg:text-6xl">
              Family Law
            </h1>
            <p className="max-w-2xl text-base leading-8 text-white/85 lg:text-lg">
              Practical family law advice for relationships, children and civil
              partnerships, with a strong focus on legal clarity and support.
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a
                href="#contact"
                className="inline-flex items-center justify-center bg-[#C9A04A] px-6 py-3 font-bold text-[rgb(26,36,58)] hover:bg-white"
              >
                Get advice
              </a>
              <a
                href="tel:+4401216306635"
                className="inline-flex items-center justify-center border border-white/40 px-6 py-3 font-bold text-white hover:border-yellow hover:text-[#C9A04A]"
              >
                Call +44 (0) 121 630 6635
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="relative overflow-hidden bg-light-grey py-8">
        <div className="container relative mx-auto px-4">
          <div className="relative z-10 text-center mb-12 max-w-3xl mx-auto">
            <h2 className="text-3xl font-bold text-[rgb(26,36,58)] mb-4">
              Family law services
            </h2>
            <p className="text-gray-700 leading-8">
              Review the main areas where we help families, parents and couples
              resolve legal matters with care and confidence.
            </p>
          </div>

          <div className="relative z-10 grid gap-6 md:grid-cols-2 xl:grid-cols-3">
            {serviceCards.map((card, idx) => {
              // Determine if this is the last card and it would be alone in the row
              const isLast = idx === serviceCards.length - 1;
              const remainderMd = serviceCards.length % 2;
              const remainderXl = serviceCards.length % 3;
              let extraClasses = '';
              if (isLast) {
                if (remainderXl === 1) {
                  extraClasses = ' xl:col-start-2';
                } else if (remainderMd === 1) {
                  extraClasses = ' md:col-start-2';
                }
              }
              return (
                <Link
                  key={card.title}
                  to={card.href}
                  className={`group rounded-3xl bg-white p-8 shadow-panel transition-all duration-200 hover:-translate-y-1 hover:shadow-lg${extraClasses}`}
                >
                  <h3 className="text-xl font-bold text-purple-600 mb-3">
                    {card.title}
                  </h3>
                  <p className="text-gray-600 leading-7">{card.description}</p>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      {/* <Quote /> */}
    </div>
  );
};

export default FamilyLaw;
